import { updateKvlGtmDataLayer } from "../kevel/audience";
/**
 * Pushes the provided object to dataLayer
 * @param {Object} obj - object to be pushed in dataLayer
 */
const pushDataLayer = (obj) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push(obj);
};

/**
 * Pushes the provided event to dataLayer
 * @param {Object} obj - event to be pushed in dataLayer
 */
const pushEventData = (obj) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push(obj);
    updateKvlGtmDataLayer();
};

/**
 * Pushes the provided array of product impressions to dataLayer
 * @param {Array} products - array of objects
 * @param {String} event - string
 */
const pushProductImpression = (products, event = "impressions") => {
    if (!products || products.length === 0) {
        return;
    }

    const productImpression = {
        "event": event,
        "ecommerce": {
            "impressions": products
        }
    };

    pushDataLayer(productImpression);
};

/**
 * Pushes the event for product view_item to dataLayer
 * @param {Object} datalayerObj datalayer object
 */
const pushProductViewItem = (datalayerObj) => {
    const productDetail = {
        "event": "view_item",
        "ecommerce": datalayerObj
    };

    pushDataLayer(productDetail);
};

/**
 * Pushes the provided array of products as a click event in the dataLayer
 * @param {Array} products
 * @param {String} list
 */
const pushProductClick = (products, list) => {
    const productClick = {
        "event": "productClick",
        "ecommerce": {
            "click": {
                "actionField": {
                    "list": list
                },
                "products": products
            }
        }
    };

    pushDataLayer(productClick);
};

/**
 * Pushes the provided promotions array to dataLayer
 * @param {Array} promotions
 * @param {String} event
 */
const pushPromoView = (promotions, event) => {
    var promoView ={
        "event": event,
        "ecommerce": {
            "promoView": {
                "promotions" : promotions
            }
        }
    };

    pushDataLayer(promoView);
};

/**
 * Pushes promotion clicks to dataLayer
 * @param {Array} promotions
 */
const pushPromoClick = (promotions) => {
    var promoClick ={
        "event": "promotionClick",
        "ecommerce": {
            "promoClick": {
                "promotions" : promotions
            }
        }
    };

    pushDataLayer(promoClick);
};

/**
 * Pushes the quickview event to dataLayer
 * @param {Array} product
 * @param {String} list
 */
const pushProductQuickView = (product, list) => {
    var productQuickView = {
        "event": "quickView",
        "ecommerce": {
            "detail": {
                "actionField": {
                    "list": list
                },
                "products": product
            }
        }
    };

    pushDataLayer(productQuickView);
};

/**
 * Push the product add to cart event to dataLayer
 * @param {Object} dataLayerObject
 */
const pushProductAddToCart = (dataLayerObject) => {
    const eventData = Object.assign({}, {"event" : "add_to_cart"}, dataLayerObject);

    pushDataLayer(eventData);
};

/**
 * Pushes the event for remove product from cart to dataLayer
 * @param {Object} dataLayerObject
 */
const pushProductRemoveFromCart = dataLayerObject => {
    const eventData = Object.assign({}, {"event" : "remove_from_cart"}, dataLayerObject);

    pushDataLayer(eventData);
};

/**
 * Push the product add to wishlist event to dataLayer
 * @param {Array} product
 */
const pushProductAddToWishlist = (product) => {
    let productAddToWishlist = {
        "event": "addToWishlist",
        "ecommerce": {
            "add": {
                "products": product
            }
        }
    };

    pushDataLayer(productAddToWishlist);
};

/**
 * Pushes the event for remove product from wishlist to dataLayer
 * @param {Array} products
 */
const pushProductRemoveFromWishlist = product => {
    const productRemoveFromWishlist = {
        "event": "removeFromWishlist",
        "ecommerce": {
            "remove": {
                "products": product
            }
        }
    };

    pushDataLayer(productRemoveFromWishlist);
};

/**
 * Pushes an event with the specified data
 * @param {String} event
 * @param {Object} data
 */
const pushEvent = (event, data) => {
    const eventData = Object.assign({}, {"event" : event}, data);

    pushEventData(eventData);
};

const pushCheckoutStep = (products, step) => {
    let productImpression = {
        "event": "checkoutStep" + step,
        "ecommerce": {
            "checkout": {
                "actionField": {
                    "step" : step
                }
            }
        }
    };

    if (products) {
        productImpression.ecommerce.checkout = Object.assign({}, productImpression.ecommerce.checkout, {
            "products": products
        });
    }

    pushDataLayer(productImpression);
};

/**
 * Pushes the refunds data to datalayer
 * @param {String} transactionID
 */
const pushRefunds = transactionID => {
    const refunds = {
        "event": "refund",
        "ecommerce": {
            "refund": {
                "actionField": {
                    "id": transactionID
                }
            }}
    };

    pushDataLayer(refunds);
};

/**
 * Pushes an event to clean the previous ecommerce object
 */
const pushCleanEcommerceObject = () => {
    pushDataLayer({"ecommerce": null});
};

export {
    pushDataLayer,
    pushEventData,
    pushProductImpression,
    pushProductViewItem,
    pushPromoView,
    pushProductClick,
    pushPromoClick,
    pushProductQuickView,
    pushProductAddToCart,
    pushProductRemoveFromCart,
    pushProductAddToWishlist,
    pushProductRemoveFromWishlist,
    pushEvent,
    pushCheckoutStep,
    pushRefunds,
    pushCleanEcommerceObject
};
